import React, { useEffect, useState } from 'react';

import { Link, useNavigate, useParams } from 'react-router-dom';

import axios from 'axios';

import swal from 'sweetalert';

import Spinner from'../../spinners/DataSpinner';

const EditCategory = () => {

    const navigate = useNavigate();

    const { id } = useParams();

    const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(true);
    const [errors, setErrors] = useState([]);


    useEffect(() => {
        axios.get(`api/edit-category/${id}`)
            .then(res => {
                if (res.data.status === 200) {
                    setFormData({
                        slug: res.data.category.slug,
                        name: res.data.category.name,
                        description: res.data.category.description,
                        meta_title: res.data.category.meta_title,
                        meta_keyword: res.data.category.meta_keyword,
                        meta_description: res.data.category.meta_description,
                        status: res.data.category.status==1 ? true : false,
                    });
                } else if (res.data.status === 404) {
                    swal("Error", res.data.message, 'error');
                    navigate("/admin/view-categories");
                }
                setLoading(false);
            });
    }, [id]);

    const handeInput = (e) => {
        e.persist();
        const {name, value, type, checked} = e.target;
        setFormData({ ...formData, [name]: type==="checkbox" ? checked : value });
    }

    if (loading) {
        return <Spinner/>
    }

    const updateCategory = (e) => {
        e.preventDefault();
        const data = formData; 
        axios.put(`api/update-category/${id}`, data)
            .then(res => {
                if (res.data.status === 200) {
                    swal("Success", res.data.message, "success");
                    setErrors([]);
                } else if (res.data.status === 422) {
                    swal("All fields are mondatory", "", "error");
                    setErrors(res.data.errors);
                } else if (res.data.status == 404) {
                    swal("Error", res.data.message, "error");
                    navigate("/admin/view-categories");
                }
            });
    }


    return (
        <form onSubmit={updateCategory} id="CATEGORY-FORM">
            <div className="card shadow mb-4">
                <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                    <h3 className="h5 mb-0 text-gray-800">Edit Category</h3>
                    <Link to="/admin/view-categories" className="btn btn-primary btn-md">View Categories</Link>
                </div>
                <div className="card-body">
                    <ul className="nav nav-pills">
                        <li className="nav-item">
                            <a className="nav-link active" data-bs-toggle="pill" href="#main-details">
                                Main Details
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" data-bs-toggle="pill" href="#seo-details">
                                SEO Details
                            </a>
                        </li>
                    </ul>
                    <div className="tab-content">
                        <div className="tab-pane container active" id="main-details">
                            <div className="mb-3 mt-3">
                                <label className="form-label">slug</label>
                                <input type="text" className="form-control" name="slug" onChange={handeInput} value={formData.slug} />
                                <span>{errors.slug}</span>
                            </div>
                            <div className="mb-3 mt-3">
                                <label className="form-label">Name</label>
                                <input type="text" className="form-control" name="name" onChange={handeInput} value={formData.name} />
                            </div>
                            <div className="mb-3 mt-3">
                                <label className="form-label">Description</label>
                                <textarea className="form-control" name="description" onChange={handeInput} value={formData.description}></textarea>
                                <span>{errors.description}</span>
                            </div>
                            <div className="mb-3 mt-3">
                                <label className="form-label pr-2">Status</label>
                                <input type="checkbox" name="status" onChange={handeInput} value={formData.status} checked={formData.status} />
                                <span className='pl-3'> Status 0 = shown, 1 = hidden</span>
                            </div>
                        </div>
                        <div className="tab-pane container fade" id="seo-details">
                            <div className="mb-3 mt-3">
                                <label className="form-label">Title</label>
                                <input type="text" className="form-control" name="meta_title" onChange={handeInput} value={formData.meta_title} />
                                <span>{errors.meta_title}</span>
                            </div>
                            <div className="mb-3 mt-3">
                                <label className="form-label">Keywords</label>
                                <input type="text" className="form-control" name="meta_keyword" onChange={handeInput} value={formData.meta_keyword || ''} />

                            </div>
                            <div className="mb-3 mt-3">
                                <label className="form-label">Description</label>
                                <textarea className="form-control" name="meta_description" onChange={handeInput} value={formData.meta_description || ''}></textarea>

                            </div>
                        </div>
                    </div>
                </div>

                <button type="submit" className="btn btn-primary mb-2 mr-3 ml-3">Update</button>

            </div>
        </form>
    );
}

export default EditCategory;